import axios from "axios";

function APIKit(isMultipart = false, customHeaders) {
  const SERVER_API = process.env.REACT_APP_KG_ASSESMENT_BASE_URL;
  const Kit = axios.create({
    baseURL: SERVER_API,
    timeout: 30000,
    headers: {
      ...customHeaders, // Add custom headers here
    },
  });

  const responseHandler = (response) => {
    if (response.status === 401) {
      // Force logout
    }
    return response;
  };

  const errorHandler = async (error) => {
    if (error?.response?.data?.status === 401) {
      localStorage?.setItem("isLoggedIn", null);
      localStorage?.setItem("userDetails", null);
      window.location.href = "/login";
    }
    if (error.response) {
      return error.response;
    } else {
      return error;
    }    
  };

  Kit.interceptors.request.use(async function (config) {
    if (isMultipart) {
      config.headers["Content-Type"] = "multipart/form-data";
    }
    const userDetails = JSON.parse(localStorage?.getItem("userDetails"));
    const fcmToken = localStorage?.getItem("fcmToken");
    if (userDetails?.token) {
      config.headers["x-access-token"] = `${userDetails?.token}`;
      config.headers["fcm_token"] = `${fcmToken}`;
    }
    return config;
  });

  Kit.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => errorHandler(error)
  );

  return Kit;
}

export default APIKit;
